module.exports = __webpack_public_path__ + "static/media/guide_reversal_1.078ffacc.svg";